module.exports = __webpack_public_path__ + "img/down.dc68b698.gif";